import { useState } from "react";

export const useModalConfirm = () => {
  const [modalConfirm, setModalConfirm] = useState({
    show: false,
    // Valores por defecto
    title: "",
    description1: "",
    description2: "",
    question: "",
    variant: "light",
    titleColor: "secondary",
    buttonSize: "small",
    loading: false,
    leftButtonText: "Cancelar",
    leftButtonColor: "secondary",
    leftButtonVariant: "outlined",
    leftIconName: "",
    leftIconColor: "",
    leftIconColorHover: "",
    onClickLeft: null,
    rightButtonText: "Confirmar",
    rightButtonColor: "primary",
    rightButtonVariant: "contained",
    rightIconName: "",
    rightIconColor: "",
    rightIconColorHover: "",
    onClickRight: null,
    ethiquin: "inspector",
    inputLabel: "",
    inputValue: "",
    setInputValue: () => {},
    hasInvDescription: false,
  });

  const openModalConfirm = (config = {}) => {
    setModalConfirm({
      ...modalConfirm,
      ...config,
      show: true,
    });
  };

  const closeModalConfirm = () => {
    setModalConfirm((prevState) => ({ ...prevState, show: false }));
  };

  return { modalConfirm, openModalConfirm, closeModalConfirm };
};
